import axios from 'axios';
import AuthStorage from '../modules/authStorage';
const baseUrl = process.env.REACT_APP_WEB3_BE_ENDPOINT;

const setAuth = async (accessToken, refreshToken) => {
  AuthStorage.setTokens(accessToken, refreshToken);
};

export const mintNFT = async (payload, token) => {
  try {
    const res = await axios.post(
      `${baseUrl}/api/v1/mintAndTransferNft/academy`,
      payload,
      { headers: { Authorization: 'Bearer '.concat(token) } },
    );
    const data = res.data;
    const { accessToken, refreshToken } = data || {};
    // Set auth tokens promise
    await setAuth(accessToken, refreshToken);
    return {
      data: data,
      error: null,
    };
  } catch (e) {
    return {
      data: null,
      error: e,
    };
  }
};
